import usePreference from './use-preference.js';
import { Measurements } from './measurements.jsx';
import { useMemo } from 'react';

export default function useMeasurement({ name, metricOverride, requireMetric, fallbackPreference }) {
  const prefs = usePreference({ key: 'metrics' });
  const measurement = Measurements.getFromPrefs({ prefs, name, metricOverride, requireMetric, fallbackPreference });

  // to avoid re-renders when things use the measurement as a dependency, return the previous
  // if nothing has changed.
  return useMemo(
    () => measurement,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [`${name}#${measurement?.metric}#${measurement?.system}#${measurement?.unit}`],
  );
}
